import React, { useEffect, useState } from 'react';
import { orderAPI } from './SellerApi';

const STATUS_FLOW = {
  pending: ['processing', 'cancelled'],
  processing: ['shipped'],
  shipped: ['delivered']
};

export const SellerOrders = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState({});

  useEffect(() => {
    orderAPI.list()
      .then(r => setOrders(r.data || []))
      .catch(() => setOrders([
        { id: 'ATR-9921', product_name: 'Premium Denim Jacket', customer_name: 'Raji K.', status: 'pending', total: 1499, created_at: '2026-05-14', qty: 1 },
        { id: 'ATR-9920', product_name: 'Smart Fitness Band', customer_name: 'Siva M.', status: 'shipped', total: 2499, created_at: '2026-05-13', qty: 1 }
      ]))
      .finally(() => setLoading(false));
  }, []);

  const updateStatus = async (id, nextStatus) => {
    setUpdating(prev => ({ ...prev, [id]: true }));
    try {
      await orderAPI.updateStatus(id, nextStatus);
      setOrders(prev => prev.map(o => o.id === id ? { ...o, status: nextStatus } : o));
    } catch (err) {
      alert(err.message || "Failed to update status");
    } finally {
      setUpdating(prev => ({ ...prev, [id]: false }));
    }
  };

  const filtered = orders.filter(o => filter === 'all' || o.status === filter);

  return (
    <div className="sp-card">
      <div className="sp-orders-header">
        <div className="sp-card-title">Orders Management</div>
        <div className="sp-tabs">
          {['all', 'pending', 'processing', 'shipped', 'delivered', 'cancelled'].map(t => (
            <button key={t} className={`sp-tab ${filter === t ? 'active' : ''}`} onClick={() => setFilter(t)}>
              {t.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="sp-skeleton" style={{ height: 250 }} />
      ) : (
        <div className="sp-table-wrap">
          <table className="sp-table">
            <thead>
              <tr><th>Order ID</th><th>Product</th><th>Customer</th><th>Qty</th><th>Total</th><th>Date</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {filtered.map(o => (
                <tr key={o.id}>
                  <td className="td-hi">#{o.id}</td>
                  <td>{o.product_name}</td>
                  <td>{o.customer_name}</td>
                  <td>{o.qty || 1}</td>
                  <td className="td-em">₹{o.total}</td>
                  <td style={{ fontSize: 12, color: 'var(--t3)' }}>{new Date(o.created_at).toLocaleDateString('en-IN')}</td>
                  <td><span className={`sp-badge ${o.status}`}>{o.status}</span></td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                      {STATUS_FLOW[o.status]?.map(next => (
                        <button key={next} className="sp-btn-secondary" style={{ padding: '4px 10px', fontSize: 11 }}
                          disabled={updating[o.id]} onClick={() => updateStatus(o.id, next)}>
                          → {next}
                        </button>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: 'center', color: 'var(--t3)', padding: '2rem' }}>No orders found under this status.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};